import React from 'react';
import { ExportHistoryPage } from './export-history';
import { ExportHistoryApiProvider } from './use-export-history';
import { usePageTitle } from '../../hooks';

import "./index.css";

interface ExportHistoryDashboardProps { }

export const ExportHistoryDashboard: React.FunctionComponent<
  ExportHistoryDashboardProps
> = (props) => {
  usePageTitle('Export History');

  return (
    <ExportHistoryApiProvider>
      <ExportHistoryPage />
    </ExportHistoryApiProvider>
  );
};

export * from './export-provider';
